import React, { useLayoutEffect, useContext } from "react";
import { useSelector } from "react-redux";
import ApiBenchmark from "../../../app/api/admin/benchmark/ApiBenchmark";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import { ContextContent } from "../../modules/content/contentContext";
import List from "../../modules/list";
import useListFilters from "../../modules/list/useListFilters";
import ListHeaderItem from "../../modules/list/__header-item";
import ListBodyItem from "../../modules/list/__body-item";
import ButtonLinkShow from "../../components/button-link/__show";
import Select from "../../components/inputs/select";
import InputNumber from "../../components/inputs/number/number";
import DateLib from "../../../inc/DateLib";
import "./styles.css";

// Раздел «Бенчмарки»: СКВОЗНОЙ по всей ферме список замеров PCMark (authorized/admin/benchmarks),
// ради сравнения тарифов/нод между собой. Не подраздел устройства. Read-only: только список +
// карточка, без create/edit/destroy (строки пишет скрипт). Фильтры — id устройства, тариф и нода
// (тариф и нода — из state.option), значения — в URL; сортировка/пагинация — штатным модулем
// List. См. спецификацию §4.
export default function BenchmarksIndex({ ...other }) {
    return <Page {...other}>
        <BenchmarksIndexContent/>
    </Page>;
}

function BenchmarksIndexContent() {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);
    const deviceTypes = useSelector((state) => state.option.deviceTypes);
    const nodes = useSelector((state) => state.option.nodes);

    // Фильтры — в URL (useListFilters), как сортировка и страница: на раздел ссылаются со страницы
    // «Устройства» (/benchmarks?device_id=N), и переход с другого устройства меняет выдачу уже
    // открытой страницы.
    const filter = useListFilters(['device_id', 'device_type_id', 'node_id']);

    useLayoutEffect(() => {
        contextContent.setTitle('Бенчмарки');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filters = [
        <InputNumber className="input_wf" value={filter.values.device_id}
            onChange={(event) => filter.setValue('device_id', event.target.value)}>id устройства</InputNumber>,
        <Select className="input_wf" options={deviceTypes} value={filter.values.device_type_id} isNull={true}
            onChange={(event) => filter.setValue('device_type_id', event.target.value)}>Тариф</Select>,
        <Select className="input_wf" options={nodes} value={filter.values.node_id} isNull={true}
            onChange={(event) => filter.setValue('node_id', event.target.value)}>Нода</Select>,
    ];

    // Сортируемые колонки — ровно те, что вайтлистит бэк (спецификация §4.1):
    // id, value, created_at, device_name, node_name, device_type_code. type не в списке.
    const header = [
        <ListHeaderItem key="device_name" name="device_name">Устройство</ListHeaderItem>,
        <ListHeaderItem key="node_name" name="node_name">Нода</ListHeaderItem>,
        <ListHeaderItem key="device_type_code" name="device_type_code">Тариф</ListHeaderItem>,
        <ListHeaderItem key="type" name="type" isSort={false}>Тип</ListHeaderItem>,
        <ListHeaderItem key="value" name="value">Балл</ListHeaderItem>,
        <ListHeaderItem key="created_at" name="created_at">Создан</ListHeaderItem>,
        <ListHeaderItem key="show" name="show" isSort={false}></ListHeaderItem>,
    ];

    const renderRow = (row) => [
        <ListBodyItem key="device_name">{row.device_name ?? `#${row.device_id}`}</ListBodyItem>,
        <ListBodyItem key="node_name">{row.node_name ?? '—'}</ListBodyItem>,
        <ListBodyItem key="device_type_code">{row.device_type_code ?? '—'}</ListBodyItem>,
        <ListBodyItem key="type">{row.type}</ListBodyItem>,
        <ListBodyItem key="value">{row.value}</ListBodyItem>,
        <ListBodyItem key="created_at">{DateLib.formatterDateTime(row.created_at)}</ListBodyItem>,
        <ListBodyItem key="show">
            <ButtonLinkShow className="button-link_blue" title="Разбивка по подтестам"
                href={contextPage.routes.show.url({ id: row.id })}/>
        </ListBodyItem>,
    ];

    return <List
        header={header}
        ApiModel={ApiBenchmark}
        renderRow={renderRow}
        filters={filters}
        defaultSortKey="created_at"
        defaultSortIsAsc={false}
        searchParams={filter.applied}
        onApplyFilters={filter.apply}
        onResetFilters={filter.reset}
    />;
}
